import React, { useContext } from "react";
import { AuthContext } from "../../components/user/BCPAuthProvider";
import { Box, Button, Grid, Link, Typography } from "@mui/material";
import Hero from "../../components/layout/Hero";
import {
  BCPSearch,
  BCPArrowRightFromBracket,
} from "../../components/icons/bcp/BCPIcons";
import HighlightedEvents from "../../components/utilities/HighlightedEvents";
import FeaturedEvents from "../../components/utilities/FeaturedEvents";
import { getEnvironmentVariable } from "../../global/environmentVariables";
const SYSTEM_IMAGES_CLOUDFRONT = getEnvironmentVariable(
  "SYSTEM_IMAGES_CLOUDFRONT"
);

export default function HomeChronoCore() {
  const authContext = useContext(AuthContext);
  return (
    <>
      <Hero
        backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/hero1.jpg`}
        backgroundTint={
          "linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.3))"
        }
        sxBackground={{
          height: ["unset", "70vh"],
          maxHeight: ["unset", "600px"],
          minHeight: "unset",
          color: "common.white",
        }}
      >
        <img
          src={`${SYSTEM_IMAGES_CLOUDFRONT}/images/hero1-logo.png`}
          alt=""
          style={{
            maxHeight: "300px",
            maxWidth: "65%",
          }}
        />
        <Typography variant="h1" align="left" color="inherit" paragraph>
          Enter The Arena, Commence Battle
        </Typography>
        <Box sx={{ marginBottom: 4 }}>
          <Grid container spacing={2} justifyContent="left">
            <Grid item>
              <Button
                href="/play/events"
                variant="contained"
                color="primary"
                startIcon={<BCPSearch />}
              >
                ARENA EVENT
              </Button>
            </Grid>
            {!authContext?.authState?.isAuthenticated ? (
              <Grid item>
                <Button
                  href="/login"
                  variant="contained"
                  color="secondary"
                  startIcon={<BCPArrowRightFromBracket />}
                >
                  Login
                </Button>
              </Grid>
            ) : (
              <Grid item>
                <Button
                  focusRipple
                  href="/subscription"
                  variant="contained"
                  color="success"
                >
                  Subscribe
                </Button>
              </Grid>
            )}
          </Grid>
        </Box>
      </Hero>
      <FeaturedEvents />
      <HighlightedEvents />

      <Hero
        backgroundImage={`${SYSTEM_IMAGES_CLOUDFRONT}/images/hero2.jpg`}
        backgroundTint
        sxBackground={{
          height: ["unset", "70vh"],
          maxHeight: ["unset", "700px"],
          minHeight: "unset",
          color: "common.white",
        }}
        maxWidth="md"
      >
        <Grid container>
          <Grid item xs={12} md={6} lg={8}>
            <Typography variant="h1" align="left" color="inherit" paragraph>
              Pilots.
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              The Best Coast Pairings player app for iOS and Android is a
              player's connection to competitive events. Using the Player App
              you can search for, browse through and register for events. Also,
              see table assignments and pairings and view placings for any
              ongoing events. Players who are participating in the event can
              securely check in and remotely score as well as see any submitted
              lists at the event.
            </Typography>
            <Typography variant="body1" align="left" color="inherit" paragraph>
              <Link
                href={
                  authContext?.authState?.identity?.subscriber
                    ? "/account"
                    : "/subscription/player"
                }
                underline="none"
                sx={{
                  color: "green",
                }}
              >
                Subscribe
              </Link>{" "}
              and see any submitted list, deck or crew for any event world wide
              and get exclusive discounts and rewards.
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            md={6}
            lg={4}
            sx={{
              pt: [1, 1, 12],
            }}
          >
            <Box sx={{ marginBottom: 4 }}>
              <Grid
                container
                spacing={2}
                sx={{
                  justifyContent: ["center", "center", "right"],
                }}
              >
                {!authContext?.authState?.identity?.subscriber && (
                  <Grid item xs={12}>
                    <Button
                      focusRipple
                      style={{
                        width: "150px",
                        height: "44px",
                      }}
                      href="/subscription/player"
                      variant="contained"
                      color="success"
                    >
                      Subscribe
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Hero>
    </>
  );
}
